/**
 * 执行业务 hooks
 * @param {string} key - hooks 类型
 */
export const runHooks = function (hooks, ...args) {
  if (!hooks) return
  if (Array.isArray(hooks) && hooks.length) {
    let res
    hooks.forEach(fn => {
      if (typeof fn === 'function') {
        res = fn.call(this, ...args, res)
      }
    })
    return res
  } else if (typeof hooks === 'function') {
    return hooks.call(this, ...args)
  }
}

/**
 * 执行异步业务 hooks
 * @param {string} key - hooks 类型
 */
export const runAsyncHooks = async function (hooks, ...args) {
  if (!hooks) return Promise.resolve()
  try {
    if (Array.isArray(hooks) && hooks.length) {
      let res
      for (const hook of hooks) {
        const _res = await hook.call(this, ...args, res)
        res = _res
      }
      return Promise.resolve(res)
    } else if (typeof hooks === 'function') {
      const res = await hooks.call(this, ...args)
      return Promise.resolve(res)
    }
  } catch (error) {
    return Promise.reject(error)
  }
}
